/*
 * Add-to-cart bridge for converted Replo sections.
 *
 * Replo's runtime posted to /cart/add.js itself. Reimplementing that would work
 * in isolation but silently drop the apps that hook the real product form -
 * EasyGift adds a free Heated Attachment on this product, and product-air.js
 * attaches a warranty upsell to `buy-buttons button[type=submit]`. Both listen
 * to the theme's own form, not to Replo.
 *
 * So converted buttons delegate to the native buy box instead of adding to cart
 * themselves. Same code path, same apps, same analytics - no duplicate logic to
 * drift out of sync with the theme.
 *
 * Only ONE Replo add-to-cart on the AIR page is actually reachable (s3, mobile
 * only); s1 and sticky-atc render theirs 0x0 at every viewport. This binds
 * whatever is present and visible, and no-ops otherwise.
 */
(function () {
  'use strict';

  var REPLO_ATC = '[data-replo-add-product-variant-to-cart]';
  var NATIVE_FORM = 'form.shopify-product-form';
  var NATIVE_CTA = 'button[type="submit"], [name="add"]';

  function nativeButton() {
    var main = document.querySelector('.shopify-section[id*="__main"]');
    var form = (main || document).querySelector(NATIVE_FORM);
    return form ? form.querySelector(NATIVE_CTA) : null;
  }

  function isReachable(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function bind(el) {
    if (el.dataset.atcBridged === 'true') return;
    el.dataset.atcBridged = 'true';

    el.addEventListener(
      'click',
      function (e) {
        var target = nativeButton();
        if (!target) return; // leave default behaviour alone rather than swallow the click
        e.preventDefault();
        e.stopPropagation();
        // Hand off to the theme's real buy button so every listener on the
        // product form fires exactly as it does for the main buy box.
        target.click();
      },
      true
    );
  }

  function scan() {
    document.querySelectorAll(REPLO_ATC).forEach(function (el) {
      if (isReachable(el)) bind(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Buttons can become reachable only at certain breakpoints, and the theme
  // editor re-renders sections without a page load.
  window.addEventListener('resize', scan);
  document.addEventListener('shopify:section:load', scan);
})();
